import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RedactionSummary } from "../../types/shared.types";

interface Props {
  summary: RedactionSummary;
}

const RedactionSummaryCard: React.FC<Props> = ({ summary }) => {
  const formatTime = (seconds: number) => {
    if (seconds < 1) return `${(seconds * 1000).toFixed(0)}ms`;
    return `${seconds.toFixed(2)}s`;
  };

  return (
    <Card className="mt-4">
      <Card.Header as="h5" className="bg-light">
        Redaction Summary
      </Card.Header>
      <Card.Body>
        <Row className="text-center">
          <Col>
            <div className="mb-2">
              <strong>Total Redactions</strong>
            </div>
            <h4 className="text-primary">{summary.total_redactions}</h4>
          </Col>
          <Col>
            <div className="mb-2">
              <strong>Unique Names</strong>
            </div>
            <h4 className="text-success">{summary.unique_names}</h4>
          </Col>
          <Col>
            <div className="mb-2">
              <strong>Repeated Names</strong>
            </div>
            <h4 className="text-danger">{summary.repeated_names}</h4>
          </Col>
          <Col>
            <div className="mb-2">
              <strong>Avg. Confidence</strong>
            </div>
            <h4 className="text-info">
              {(summary.average_confidence * 100).toFixed(1)}%
            </h4>
          </Col>
          <Col>
            <div className="mb-2">
              <strong>Processing Time</strong>
            </div>
            <h4 className="text-warning">
              {formatTime(summary.processing_time)}
            </h4>
          </Col>
        </Row>
        <div className="text-center mt-4">
          <Link to="/analytics" className="btn btn-primary">
            View Full Analytics Dashboard
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default RedactionSummaryCard;
